export function getTrimmedDescription(description: string, MAX_VISIBLE_CHARS = 42): string {
    if (description?.length > MAX_VISIBLE_CHARS) {
        return description.slice(0, MAX_VISIBLE_CHARS - 1) + '…';
    }
    return description;
}
